import React, { useState, useEffect, useCallback } from "react";
import {
  Form,
  Icon,
  Header,
  Image,
  Button,
  Grid,
  Segment,
  Dimmer,
  Loader,
  List,
  Card,

} from "semantic-ui-react";
import numeral from "numeral";
import APIService from "../../Services/API/APIService";
import ReactDatePicker from "react-datepicker";
import dayjs from "dayjs";
import moment from "moment";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import Checkout from "../Checkout/Checkout";


const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16,
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid #eaeaea",
  marginBottom: 8,
  marginRight: 8,
  width: 60,
  height: 60,
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

// const img = {
//   display: "block",
//   width: "auto",
//   height: "100%",
// };

const RoomDetail = (props) => {

  const [loading, setLoading] = useState(false);
  const [room, setRoom] = useState(null);
  // const [payload, setPayload] = useState(null)
  const [displayIndex, setIndex] = useState(0); //firt gallery image
  const [bookedDays, setBookedDays] = useState([])
  const [user, setUser] = useState(null)
  const [formState, setFormState] = useState(false)
  const [formFirstname, setFormFirstname] = useState('')
  const [formLastName, setFormLastname] = useState('')
  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

  const schema = Yup.object().shape({

    firstname: Yup.string().required('Required'),
    lastname: Yup.string().required('Required'),
    email: Yup.string().email().required('Required'),
    phoneNumber: Yup.string().required('Required').matches(phoneRegExp, 'Phone number is not valid').test('len', 'Must be between 11 to 13 characters',
      val => !val || (val && val.toString().length >= 11 && val.toString().length < 14)),
    checkin: Yup.date().required('Required'),
    checkout: Yup.date().required('Required'),
  });

  const params = useParams()


  const formFields = async () => {
    try {
      const response = await APIService.fetchUser()

      if (response && response.group[0] === 'COOPERATOR') {

        setUser(response)
        setFormState(true)
        let name = response?.name.split(' ')
        setFormFirstname(name[0])
        setFormLastname(name[1])
      }
      if (response && response.group[0] === 'CUSTOMER') {

        setUser(response)
        setFormState(true)

        setFormFirstname(response.firstname)
        setFormLastname(response.lastname)
      } else {
        setUser(response)
      }


    } catch (error) {
      setFormState(false)
      console.log(error);
    }
  }
  const fetchData = useCallback(async (isSubscribed) => {
    try {
      setLoading(true);
      let response = await APIService.getData('/guest-house/getBookedDays', {
        room: params.code
      })

      let result = await APIService.getData("/guest-house/getPackages", {
        packages: params.code,
      });
      if (isSubscribed) {
        setBookedDays(response)
        setRoom(result)

      }
      setLoading(false);

      // const cartId = localStorage.getItem('cartId')

      // if (cartId) {
      //   await APIService.postData("/checkout/clearCurrentCartGuestHouse", {
      //     cartId: localStorage.getItem('cartId')
      //   });


      // }


    } catch (error) {
      setLoading(false);
    }
  }, [params.code])

  useEffect(() => {
    let isSubscribed = true
    formFields()
    fetchData(isSubscribed);

    return () => (isSubscribed = false)
  }, [fetchData]);

  const filterDate = date => {
    for (const day of bookedDays) {
      if (moment(date).isSame(day)) { return false; }
    }
    return true;
  };
  const checkForDateClash = (startDate, endDate) => {
    try {
      for (const bookedDay of bookedDays) {
        if (
          moment(bookedDay).isBetween(startDate, endDate, 'days', '[]')

        ) {
          return true; //date clash
        }
      }
      return false;
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const _saveBooking = async (values) => {

    try {
      setLoading(true);
      let clash = checkForDateClash(
        values.checkin,
        values.checkout,

      );

      if (clash) {
        toast.warning(
          "Date clash: selected cannot dates can't overlapped with unavilable dates"
        );
        setLoading(false);
        return;
      }
      if (user === null) {

        let { token } = await APIService.postDataNoAuth('/auth/guestAuth', {
          email: values.email,
          phone: values.phoneNumber,

        })
        APIService.storeToken(token)
        const authResponse = await APIService.checkAuth()
        APIService.storeUser(authResponse.user)
      }


      let nights = dayjs(values.checkout).diff(values.checkin, "day");

      //add to cart
      let payload = {
        Id: params.code,
        checkin: values.checkin,
        checkout: values.checkout,
        nights: nights,
        email: values.email,
        firstname: values.firstname,
        lastname: values.lastname,
        phone: values.phoneNumber,
        price: room?.price,
        roomName: room?.name

      };




      let response = await APIService.postData("/checkout/addGuestHouseCart", payload);
      localStorage.setItem('cartId', response?.cartId)
      payload.reservationToken = response?.reservationToken
      localStorage.setItem('payload', JSON.stringify(payload))


      if (response) {
        //setPayload(payload)
        setLoading(false);
      }

    } catch (error) {
      console.log("error", error);
    }
  };

  if (localStorage.getItem('payload') && localStorage.getItem('cartId') != null) return <Checkout />

  return (
    <Segment>
      {loading && (
        <Dimmer active inverted>
          <Loader> Please wait ... </Loader>
        </Dimmer>
      )}

      {room && (
        <Grid columns={2} stackable style={{ backgroundColor: '#eee' }} >
          <Grid.Row>
            <Grid.Column >
              <Grid.Row>

                {room.GuestHouseGalleries[0] ? (
                  <div style={{ alignSelf: "center" }}>
                    <Image
                      src={room.GuestHouseGalleries[displayIndex]?.resizeLocation}
                      style={{ height: 400 }}
                    />
                  </div>

                ) : (
                  <div style={{ alignSelf: "center" }}>
                    <Image
                      src="https://st.depositphotos.com/1987177/3470/v/600/depositphotos_34700099-stock-illustration-no-photo-available-or-missing.jpg"
                      style={{ height: 400 }}
                    />
                  </div>
                )}

              </Grid.Row>
              <Grid.Row>
                <aside style={thumbsContainer}>
                  {room.GuestHouseGalleries?.map((pic, index) => (
                    <div
                      style={thumb}
                      key={pic.id}
                      onClick={() => setIndex(index)}
                    >
                      <div style={thumbInner}>
                        <Image src={pic.resizeLocation} />
                      </div>
                    </div>
                  ))}
                </aside>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column textAlign="left">
              <Segment inverted>
                <Header as={'H1'} style={{ color: '#26f09e' }}> {room.name} </Header>

                <div style={{ marginTop: 10, color: 'teal', fontWeight: 'bolder', fontSize: '2em' }}>

                  ₦{numeral(room?.price).format("0,0")}

                </div>

                <List horizontal divided size="large">
                  {room.description.split("\n").map((item, index) =>
                    <List.Item key={index}>
                      <List.Content>
                        <Icon name="arrow alternate circle right" />
                        {item}

                      </List.Content>
                    </List.Item>
                  )}

                </List>

                <Card.Description>
                  <Formik
                    enableReinitialize={true}
                    initialValues={{

                      firstname: '' || formFirstname,
                      lastname: '' || formLastName,
                      email: '' || user?.email,
                      phoneNumber: '' || user?.phone,
                      checkin: "",
                      checkout: "",
                    }}
                    validationSchema={schema}
                    onSubmit={(values, { resetForm }) => {
                      _saveBooking(values);
                      resetForm();
                    }}
                  >
                    {(props) => {
                      const {
                        values,
                        touched,
                        errors,
                        handleChange,
                        handleSubmit,
                      } = props;
                      return (
                        <Form onSubmit={handleSubmit}>

                          <Form.Group widths={2}>
                            <Form.Input


                              placeholder="First Name"
                              name="firstname"
                              value={values.firstname || formFirstname}
                              onChange={handleChange}
                              disabled={formState}
                              error={touched.firstname && errors.firstname}
                            />
                            <Form.Input

                              placeholder="Last Name"
                              name="lastname"
                              value={values.lastname || formLastName}
                              onChange={handleChange}
                              disabled={formState}
                              error={touched.lastname && errors.lastname}
                            />
                          </Form.Group>

                          <Form.Group widths={2} >
                            <Form.Input

                              placeholder="Email"
                              name="email"
                              value={values.email || user?.email}
                              disabled={formState}
                              onChange={handleChange}
                              error={touched.email && errors.email}
                            />

                            <Form.Input
                              placeholder="Phone Number"
                              name="phoneNumber"
                              value={values.phoneNumber || user?.phone}
                              onChange={handleChange}
                              error={touched.phoneNumber && errors.phoneNumber}
                              type={'phone'}
                            />
                          </Form.Group>


                          <Form.Group widths={2}>
                            <Form.Input
                              control={ReactDatePicker}
                              placeholderText="Select checkin  date"
                              minDate={dayjs().toDate()}
                              maxDate={dayjs().add(3, "month").toDate()}
                              filterDate={filterDate}
                              selected={
                                values.checkin
                                  ? dayjs(values.checkin).toDate()
                                  : ""
                              }
                              onChange={(value) => {
                                props.setFieldValue("checkin", value);
                              }}
                              error={touched.checkin && errors.checkin}
                            />

                            <Form.Input
                              control={ReactDatePicker}
                              disabled={!values.checkin}
                              placeholderText="Select checkout date"
                              minDate={dayjs(values.checkin).add(1, "day").toDate()}
                              filterDate={filterDate}
                              selected={
                                values.checkout
                                  ? dayjs(values.checkout).toDate()
                                  : ""
                              }
                              onChange={(value) => {
                                props.setFieldValue("checkout", value);
                              }}
                              error={touched.checkout && errors.checkout}
                            />
                          </Form.Group>

                          <Button type='submit' style={{ backgroundColor: '#26f09e', color: '#000000' }} > <Icon name='calendar alternate' />Book Now</Button>
                        </Form>
                      );
                    }}
                  </Formik>


                </Card.Description>

              </Segment>

            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}

    </Segment>
  );
};

export default RoomDetail;
